import { css } from '@emotion/react'
import { Cell, Flow, FormControl, Grid, Theme, useTheme } from 'bold-ui'
import { CnsField, DateField, TextField } from 'components/form'
import { CidadaoAtendimentoContextModel } from 'hooks/atendimento-context/model-atendimentoContext'
import { toDate } from 'util/date/formatDate'

import { CitopatologicoPerguntaField } from './model-citopatologico'

interface CitopatologicoDadosColetaModalStepProps {
  cidadao: CidadaoAtendimentoContextModel
  serverTime: Date
}

export function CitopatologicoDadosColetaModalStep(props: Readonly<CitopatologicoDadosColetaModalStepProps>) {
  const { cidadao, serverTime } = props

  const dataNascimentoAsDate = toDate(cidadao.dataNascimento)

  const theme = useTheme()
  const styles = createStyles(theme)

  return (
    <Grid>
      <Cell data-testid='dataDaColeta'>
        <DateField
          name={CitopatologicoPerguntaField.dataDaColeta}
          label='Data da coleta'
          minDate={dataNascimentoAsDate ?? undefined}
          maxDate={serverTime}
          required
        />
      </Cell>
      <Cell size={10} data-testid='responsavel'>
        <Flow direction='vertical' style={styles.container}>
          <FormControl label='Responsável pela coleta' style={styles.title} required />
          <TextField
            name={CitopatologicoPerguntaField.nomeResponsavel}
            label='Nome'
            required
            data-testid='nomeResponsavel'
          />
          <CnsField name={CitopatologicoPerguntaField.cns} label='CNS' required clearable data-testid='cns' />
        </Flow>
      </Cell>
      <Cell size={10} data-testid='conselho'>
        <Flow direction='vertical' style={styles.container}>
          <FormControl label='Conselho' style={styles.title} required />
          <TextField
            name={CitopatologicoPerguntaField.siglaNomeConselho}
            label='Nome'
            required
            clearable
            data-testid='siglaNomeConselho'
          />
          <TextField
            name={CitopatologicoPerguntaField.numeroConselho}
            label='Número'
            required
            clearable
            data-testid='numeroConselho'
          />
        </Flow>
      </Cell>
    </Grid>
  )
}

const createStyles = (theme: Theme) => ({
  container: css`
    position: relative;
    margin-top: 1rem;
    padding: 1rem;
    border: 1px solid ${theme.pallete.gray.c80};
  `,
  title: css`
    font-weight: bold;
    position: absolute;
    top: -0.75rem;
    margin-left: -0.75rem;
    padding: 0 0.5rem;
    background-color: ${theme.pallete.surface.main};
  `,
})
